import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    handle: { type: String, default: ".drag-handle" },
    animation: { type: Number, default: 150 }
  }

  static targets = ["item"]

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.handleValue,
      animation: this.animationValue,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onEnd(_event) {
    const orderedIds = Array.from(this.element.children)
      .filter((el) => el.dataset.id)
      .map((el) => el.dataset.id)

    // Update visual position numbers
    this.updatePositionNumbers()

    try {
      const response = await patch(this.urlValue, {
        body: JSON.stringify({ ordered_ids: orderedIds }),
        contentType: "application/json",
        responseKind: "json"
      })

      if (!response.ok) {
        console.error("Failed to save order")
        // Optionally reload to restore original order
      }
    } catch (error) {
      console.error("Error saving order:", error)
    }
  }

  updatePositionNumbers() {
    const items = this.element.querySelectorAll("[data-position-badge]")
    items.forEach((badge, index) => {
      badge.textContent = index + 1
    })
  }
}
